import API from "./axios";

const purchaseOrderApi = {
  getAll:         (purchaseType)   => API.get(`/purchase-orders${purchaseType ? `?purchaseType=${purchaseType}` : ""}`),
  /** Phase 5 — paged register. params: { page, size, sortBy, sortDir, q, status, purchaseType, vendorId, fromDate, toDate } */
  paged:          (params)         => API.get("/purchase-orders/paged", { params }),
  getById:        (id)             => API.get(`/purchase-orders/${id}`),
  downloadPdf:    (id)             => API.get(`/purchase-orders/${id}/pdf`, { responseType: "arraybuffer" }),
  getByStatus:    (status)         => API.get(`/purchase-orders/status/${status}`),
  getByVendor:    (vendorId)       => API.get(`/purchase-orders/vendor/${vendorId}`),
  getByDateRange: (from, to)       => API.get(`/purchase-orders/date-range?from=${from}&to=${to}`),
  // Every line of the material POs in a period. params: { from, to, vendorId, status }
  materialLineReport:      (params) => API.get("/purchase-orders/material-line-report", { params }),
  materialLineReportPdf:   (params) => API.get("/purchase-orders/material-line-report/pdf", { params, responseType: "blob" }),
  materialLineReportExcel: (params) => API.get("/purchase-orders/material-line-report/excel", { params, responseType: "blob" }),
  create:         (data)           => API.post("/purchase-orders", data),
  update:         (id, data)       => API.put(`/purchase-orders/${id}`, data),
  updateMeta:     (id, data)       => API.patch(`/purchase-orders/${id}/update-meta`, data),
  send:           (id)             => API.patch(`/purchase-orders/${id}/send`),
  // Take a sent/received PO back to DRAFT (refused while any GRN exists on it).
  revert:         (id)             => API.patch(`/purchase-orders/${id}/revert`),
  // Customer + school of the sale order behind a barcode, for the PO reference.
  barcodeReference: (code)         => API.get("/purchase-orders/barcode-reference", { params: { code } }),
  cancel:         (id)             => API.patch(`/purchase-orders/${id}/cancel`),
  // Phase 36da.99.sc — short-close ONE line (vendor confirmed the balance will
  // never arrive).  lineType: "CLOTH" | "MATERIAL".  Reason is required.
  shortCloseLine: (id, lineType, lineId, reason) =>
    API.post(`/purchase-orders/${id}/short-close-line`, { lineType, lineId, reason }),
  // Revise one line's rate after goods came in; refused once the line is billed.
  reviseRate:     (id, lineType, lineId, rate) =>
    API.post(`/purchase-orders/${id}/revise-rate`, { lineType, lineId, rate }),
  reopenLine:     (id, lineType, lineId) =>
    API.post(`/purchase-orders/${id}/reopen-line`, { lineType, lineId }),
  delete:         (id)             => API.delete(`/purchase-orders/${id}`),
  calculateRequirements: (soIds) => API.post("/purchase-orders/calculate-requirements", { saleOrderIds: soIds }),
  getLinkedSaleOrders: (id)    => API.get(`/purchase-orders/${id}/linked-sale-orders`),
  linkSaleOrders:     (id, soIds) => API.put(`/purchase-orders/${id}/link-sale-orders`, { saleOrderIds: soIds }),
};


/**
 * Ad-hoc material sets on a saved PO. Members are ordinary lines that also
 * belong to a set; their rate is derived from the set price and FROZEN.
 */
export const poMaterialSetApi = {
  group:   (poId, body)        => API.post(`/purchase-orders/${poId}/material-sets`, body),
  update:  (poId, setId, body) => API.patch(`/purchase-orders/${poId}/material-sets/${setId}`, body),
  ungroup: (poId, setId)       => API.delete(`/purchase-orders/${poId}/material-sets/${setId}`),
};

export default purchaseOrderApi;